// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { historyFilterProps } from "@store/Themes/common/props/history";
import * as React from "react";

const enum fields {
    isOpenByDefault = "isOpenByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isOpenByDefault]: boolean;
    };
}

export interface TrailerTrackingSearchFormStyles {
    wrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
}

export const searchFormStyles: TrailerTrackingSearchFormStyles = {
    wrapper: historyFilterProps.wrapper,
    headingText: { variant: "h5" },
};

const styles = searchFormStyles;

type Props = OwnProps;

const TrailerTrackingSearchForm: React.FunctionComponent<Props> = ({ id, fields: { isOpenByDefault } }) => {
    const [isAccordionExpended, setIsAccordionExpended] = React.useState(isOpenByDefault);
    const onToggleHandler = (expanded: boolean) => {
        setIsAccordionExpended(!expanded);
    };
    return (
        <StyledWrapper {...styles.wrapper}>
            <Accordion headingLevel={2}>
                <AccordionSection
                    title={translate("Filters")}
                    onTogglePanel={expanded => onToggleHandler(expanded)}
                    expanded={isAccordionExpended}
                >
                    <Zone contentId={id} zoneName="Content" />
                </AccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: TrailerTrackingSearchForm,
    definition: {
        group: constants.widgetGroup.trailerTracking,
        displayName: "Search Form",
        allowedContexts: [constants.pageType.trailerTracking],
        fieldDefinitions: [
            {
                name: fields.isOpenByDefault,
                displayName: "Make accordion open by default",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
